import { TextField } from "@mui/material";
import { errorsWaitListState, fechaIniWaitListState } from "../state/atoms";
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom";
import { useRecoilState } from "recoil";

export default function InputFechaIni() {
  const [fechaIni, setFechaIni] = useRecoilState(fechaIniWaitListState);
  const [errorsWaitList, setErrorsWaitList] =
    useRecoilState(errorsWaitListState);

  const handleChange = (e) => {
    setFechaIni(e.target.value);
    setErrorsWaitList((prev) => ({ ...prev, fechaIni: [] }));
  };

  return (
    <div>
      <InputLabelCustom htmlFor="inivig" text="Inicio de Vigencia (*)" />
      <TextField
        id="inivig"
        size="small"
        style={{ width: "100%" }}
        name="inivig"
        type="date"
        value={fechaIni}
        onChange={handleChange}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          min: new Date().toISOString().split("T")[0],
        }}
        variant="outlined"
        autoComplete="off"
        error={errorsWaitList.fechaIni.length > 0}
        helperText={errorsWaitList.fechaIni}
      />
    </div>
  );
}
